import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

export const setPrinterTasks = createAction('setPrinterTasks');

const getPrinterTasks = createAsyncThunk('printer/getPrinterTasks',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/printer/tasks',
        {
          params
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getPrinterTasks;
